import LandingPage from './pages/LandingPage/LandingPage';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './components/layout/Footer';
import HeaderNavBar from './components/layout/HeaderNavBar';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ClientDashboard from './pages/ClientDashboard';
import LawyerDashboard from './pages/LawyerDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { useStateHydration } from './redux/hooks';

function AppRoutes() {
  const location = useLocation();

  // Inicializar estado desde localStorage
  useStateHydration();

  // Determinar si mostrar HeaderNavBar
  const authPages = ['/login', '/signup'];
  const dashboardPages = ['/client-dashboard', '/lawyer-dashboard'];
  const showHeaderNavBar =
    !authPages.includes(location.pathname) && !dashboardPages.includes(location.pathname);

  return (
    <>
      {showHeaderNavBar && <HeaderNavBar />}
      <Routes>
        <Route path="/" element={<LandingPage key={location.pathname} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        {/* Rutas protegidas para dashboards */}
        <Route
          path="/client-dashboard"
          element={
            <ProtectedRoute requiredUserType="client">
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lawyer-dashboard"
          element={
            <ProtectedRoute requiredUserType="lawyer">
              <LawyerDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {showHeaderNavBar && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
